import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { CustomRadio } from "../../../ui/molecules/radioButton"
import { LoadNotificationsFromFile, resetLoadNotificationResponse, setLoadFromXlsFile, setNotificationSianCreationSianType } from "../slice"
import { SianTypeEnum } from "../dataservice/dto"
import { FileInputComponent } from "../../../ui/molecules/fileInput"
import { FileViewer } from "../../../ui/molecules/fileViewer"
import { TrashIcon } from "../../../ui/icons/trash"
import Button from "../../../ui/molecules/button"
import { SaveIcon } from "../../../ui/icons/SaveIcon"
import { RoundedCloseIcon } from "../../../ui/icons/CloseIcon"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"

export function NotificationAdminForms() {
    const dispatch = useAppDispatch()
    const notificationState = useAppSelector(state => state.notification)
    const [sianType, setSianType] = useState<string | null>(null)

    let formData = new FormData()

    const handleOnLoad = () => {
        formData.delete('file')
        formData.delete('notificationsSianCreationDTO')
        formData.append('file', notificationState.loadFromXlsFile!)
        formData.append('notificationsSianCreationDTO', JSON.stringify(notificationState.notificationsSianCreationRequest))
        dispatch(LoadNotificationsFromFile(formData))
    }

    return (
        <div>
            <div className="notify-container">
                <div className='notify-header'>
                    <div className='text-left'>
                        <span className='notify-title-bold' style={{ color: '#fff' }}>Gestione Notifiche </span>
                        <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> Caricamento</span>
                    </div>
                </div>

                <div style={{ padding: '24px 24px 32px 24px' }}>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className="pb-5 pt-4" style={{ display: 'flex', gap: '16px', alignItems: 'center', flex: '0.5' }}>
                            <div className="notify-subtitle text-left" style={{flex: '0.2'}}>
                                Tipologia
                            </div>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flex: '0.3' }}>
                                <CustomRadio
                                    options={[{ label: '', value: '1' }]}
                                    selectedValue={sianType}
                                    onChange={(value) => {
                                        setSianType(value)
                                        dispatch(setNotificationSianCreationSianType(SianTypeEnum.SIAN))
                                    }}
                                    id={'sian_1'}
                                    name={'sian_1'}
                                />
                                <div className='text-left'>
                                    <span className='assignment-text-content'>SIAN</span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flex: '0.3' }}>
                                <CustomRadio
                                    options={[{ label: '', value: '2' }]}
                                    selectedValue={sianType}
                                    onChange={(value) => {
                                        setSianType(value)
                                        dispatch(setNotificationSianCreationSianType(SianTypeEnum.REGIONALE))
                                    }}
                                    id={'sian_2'}
                                    name={'sian_2'}
                                />
                                <div className='text-left'>
                                    <span className='assignment-text-content'>Regionale</span>
                                </div>
                            </div>
                        </div>
                        <div style={{flex: '1'}}>
                            <FileInputComponent
                                id={"sian-upload-add"}
                                key={"sian-upload-add"}
                                color={"green"}
                                permittedExtensions={['XML']}
                                onChange={(e) => {
                                    dispatch(setLoadFromXlsFile(e[0]))
                                }}
                            />
                        </div>
                    </div>

                    <div className="pb-5">
                        {
                            notificationState.loadFromXlsFile && (
                                <div className="pt-3" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <FileViewer
                                        toUpdate
                                        fileName={notificationState.loadFromXlsFile.name}
                                        otherInfo={notificationState.loadFromXlsFile.type}
                                    />
                                    <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => dispatch(setLoadFromXlsFile(null))}>
                                        <TrashIcon size={20} color="dimgrey" />
                                    </button>
                                </div>
                            )
                        }
                    </div>

                    {
                        notificationState.loadNotificationStatus === 'loading' && (
                            <LogoSpinnerComponent fullScreen />
                        )
                    }

                    {
                        notificationState.loadNotificationResponse && (
                            <div>
                                {
                                    notificationState.loadNotificationResponse.notificationIdentifierCreated.length > 0 && (
                                        <div className="mt-4" style={{ display: 'flex', alignItems: 'center' }}>
                                            <div className="prelievi-vertical-line" />
                                            <div className="pr-5" style={{ display: 'flex', gap: '24px' }}>
                                                <div className="text-left">
                                                    <div className="prelievi-bold-text">Notifiche create correttamente</div>
                                                    <div className="prelievi-text">{notificationState.loadNotificationResponse.notificationIdentifierCreated.map(n => `${n} `)}</div>
                                                </div>
                                                <button onClick={() => dispatch(resetLoadNotificationResponse())}>
                                                    <RoundedCloseIcon color="#166428" />
                                                </button>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    notificationState.loadNotificationResponse.notificationIdentifierFailed.length > 0 && (
                                        <div className="mt-4" style={{ display: 'flex', alignItems: 'center' }}>
                                            <div className="prelievi-vertical-line-fail" />
                                            <div>
                                                <div className="text-left">
                                                    <div className="prelievi-bold-text-fail">Errore creazione notifiche</div>
                                                </div>
                                                <div className="pr-5" style={{ display: 'flex', gap: '24px' }}>
                                                    <div className="text-left">
                                                        <div className="prelievi-text-fail">{notificationState.loadNotificationResponse.notificationIdentifierFailed.map(n => `${n} `)}</div>
                                                    </div>
                                                    <button onClick={() => dispatch(resetLoadNotificationResponse())}>
                                                        <RoundedCloseIcon color="#940500" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }

                    <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={notificationState.loadFromXlsFile === null ||
                                notificationState.notificationsSianCreationRequest.sianType === undefined}
                            variant="solid"
                            color="dimgrey"
                            size="md"
                            iconPosition="left"
                            icon={<SaveIcon />}
                            label="Carica notifica"
                            onClick={() => handleOnLoad()}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}